export default __webpack_public_path__ + "static/media/ic-practice-quiz.70e1465a.svg";